export default function globalStateManager() {
  let instance = null;

  function saveFlagToLocalStorage(key, value) {
    localStorage.setItem("flag-" + key, JSON.stringify(value));
  }

  function loadFlagFromLocalStorage(key) {
    const value = localStorage.getItem("flag-" + key);
    return value ? JSON.parse(value) : false;
  }

  function createInstance() {
    let previousScene = null;
    let currentScene = null;
    let freezePlayer = false;
    let locale = "english";
    let fontSize = 25;
    let chosenEnding = null; 
    let hasKey = false;
    let hasSword = false;
    let flags = {};

    return {
      // Previous scene management
      setPreviousScene(sceneName) {
        previousScene = sceneName;
      },
      getPreviousScene() {
        return previousScene;
      },

      // Current scene management
      setCurrentScene(sceneName) {
        currentScene = sceneName;
      },
      getCurrentScene() {
        return currentScene;
      },

      // Freeze player state
      setFreezePlayer(value) {
        freezePlayer = value;
      },
      getFreezePlayer() {
        return freezePlayer;
      },

      // Locale
      setLocale(language) {
        locale = language;
      },
      getLocale() {
        return locale;
      },

      // Font size
      setFontSize(size) {
        fontSize = size;
      },
      getFontSize() {
        return fontSize;
      },

      // ✅ Chosen Ending setter/getter
      setChosenEnding(value) {
        chosenEnding = value;
      },
      getChosenEnding() {
        return chosenEnding;
      },

      setHasKey(value) {
        hasKey = value;
      },
      getHasKey() {
        return hasKey;
      },

      setHasSword(value) {
        hasSword = value;
      },
      getHasSword() {
        return hasSword;
      },

      // Flag persistence
      setFlag(key, value) {
        flags[key] = value;
        saveFlagToLocalStorage(key, value);
      },
      getFlag(key) {
        return flags[key] ?? loadFlagFromLocalStorage(key);
      },
    };
  }

  return {
    getInstance() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
}
